import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerFilledComponent } from '@web/shared/ui';
import { PublicBrandCosmeticsTileComponent } from '../public-brand-cosmetics-tile/public-brand-cosmetics-tile.component';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, tap } from 'rxjs';
import {
  PublicBrandCosmetic,
  PublicBrandCosmeticSortType,
  PublicBrandCosmeticsQuery,
  PublicBrandDataSourceService,
} from '@web/shared/module/brand';
import { PublicBrandCosmeticSortPanelComponent } from '../public-brand-cosmetic-sort-panel/public-brand-cosmetic-sort-panel.component';
import { Nillable, valueOrDefault } from '@web/utils';

@Component({
  selector: 'app-public-brand-cosmetics',
  imports: [
    CommonModule,
    SpinnerFilledComponent,
    PublicBrandCosmeticsTileComponent,
    PublicBrandCosmeticSortPanelComponent,
  ],
  templateUrl: './public-brand-cosmetics.component.html',
  styleUrl: './public-brand-cosmetics.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBrandCosmeticsComponent {
  private readonly publicBrandDataSource = inject(PublicBrandDataSourceService);

  public readonly slug = input.required<string>();

  protected cosmetics$!: Observable<PublicBrandCosmetic[]>;

  protected readonly slug$ = toObservable(this.slug);
  protected readonly valueOrDefault = valueOrDefault;
  protected readonly cosmeticsLength = signal<number>(0);

  /* prettier-ignore */
  private readonly sortType = signal<Nillable<PublicBrandCosmeticSortType>>(null);

  public constructor() {
    effect(() => this.reloadCosmeticsWithQuery(this.slug()));
  }

  public handleSortTypeChange(
    type: Nillable<PublicBrandCosmeticSortType>,
  ): void {
    this.sortType.set(type);
  }

  private reloadCosmeticsWithQuery(slug: string): void {
    this.cosmetics$ = this.publicBrandDataSource
      .fetchCosmeticsBySlug({
        slug,
        query: new PublicBrandCosmeticsQuery({
          sortType: this.sortType(),
        }),
      })
      .pipe(
        tap((cosmetics) => {
          this.cosmeticsLength.set(cosmetics.length);
        }),
      );
  }
}
